import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { items } from "@/mocks/items";
import { hotTags } from "@/mocks/site";

export default function SearchBox() {
  const [q, setQ] = useState("");
  const [focused, setFocused] = useState(false);
  const nav = useNavigate();
  const blurTimer = useRef<number | null>(null);

  const kw = q.trim().toLowerCase();
  const results =
    kw.length > 0
      ? items
          .filter(
            (i) =>
              i.title.toLowerCase().includes(kw) ||
              i.summary.toLowerCase().includes(kw) ||
              i.tags.some((t) => t.toLowerCase().includes(kw))
          )
          .slice(0, 6)
      : [];

  const go = (id: string) => {
    setQ("");
    setFocused(false);
    nav(`/item/${id}`);
  };

  return (
    <div className="relative w-full">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (results.length > 0) go(results[0].id);
        }}
        className="flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 py-1 pl-4 pr-1 shadow-sm"
      >
        <i className="ri-search-line text-lg text-foreground-400"></i>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => {
            if (blurTimer.current) window.clearTimeout(blurTimer.current);
            setFocused(true);
          }}
          onBlur={() => {
            blurTimer.current = window.setTimeout(() => setFocused(false), 150);
          }}
          placeholder="搜索你关心的瓜 / 话题 / 标签…"
          className="h-10 w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
          aria-label="站内搜索"
        />
        <button
          type="submit"
          className="inline-flex h-10 shrink-0 cursor-pointer items-center gap-1 rounded-full bg-primary-500 px-5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
        >
          搜索
        </button>
      </form>

      {focused && kw.length > 0 && (
        <div className="absolute top-full z-20 mt-2 w-full overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-lg">
          {results.length > 0 ? (
            <ul className="max-h-80 divide-y divide-background-100 overflow-auto">
              {results.map((r) => (
                <li key={r.id}>
                  <button
                    type="button"
                    onClick={() => go(r.id)}
                    className="flex w-full cursor-pointer items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm text-primary-700">
                      <i className="ri-fire-line"></i>
                    </span>
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-medium text-foreground-950">{r.title}</span>
                      <span className="block text-xs text-foreground-500">{r.reads} 阅读 · {r.comments} 评论</span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="px-4 py-5 text-center text-sm text-foreground-500">
              没有找到相关内容，换个关键词试试
            </p>
          )}
        </div>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <span className="text-xs text-foreground-500">大家都在搜：</span>
        {hotTags.slice(0, 4).map((t) => (
          <button
            key={t.name}
            type="button"
            onClick={() => setQ(t.name)}
            className="inline-flex cursor-pointer items-center gap-1 rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
          >
            <i className="ri-chat-smile-line text-primary-500"></i>
            {t.name}
          </button>
        ))}
      </div>
    </div>
  );
}